import axios from "axios";
import { API_BASE_URL, FILE_UPLOAD_URL, ZOOM_API_URL } from "./config";
import { request } from "./AxiosConfig";
import Cookies from "js-cookie";

const getWithAuth = async (url, params = {}) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  const header = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "get", // default
    headers: header,
    params: params,
    timeout: 30000, // default is `0` (no timeout)// 30 sec
    maxRedirects: 2, // default
  };
  return request(config);
};

const postWithAuth = async (url, body) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  delete axios.defaults.headers.common["Authorization"];
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "post",
    headers: headers,
    data: body,
    timeout: 30000,
    maxRedirects: 2,
  };
  return request(config);
};

const getWithoutAuth = async (url, params = {}) => {
  // delete axios.defaults.headers.common["Authorization"];
  const header = {
    "Content-Type": "application/json",
    // data: "sample",
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "get", // default
    headers: header,
    params: params,
    timeout: 30000, // default is `0` (no timeout)// 30 sec
    maxRedirects: 2, // default
  };
  return request(config);
};

const postWithoutAuth = async (url, body) => {
  delete axios.defaults.headers.common["Authorization"];
  const headers = {
    "Content-Type": "application/json",
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "post",
    headers: headers,
    data: body,
    timeout: 30000,
    maxRedirects: 2,
  };
  return request(config);
};

const get = async (url, params = {}) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  const header = {
    "Content-Type": "application/json",
    // data: "sample",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "get", // default
    headers: header,
    params: params,
    timeout: 30000, // default is `0` (no timeout)// 30 sec
    maxRedirects: 2, // default
  };
  return request(config);
};

const post = async (url, body, header) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "post",
    headers: header ?? headers,
    data: body,
    timeout: 30000,
    maxRedirects: 2,
  };
  return request(config);
};

const del = async (url, params = {}) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "delete",
    headers: headers,
    timeout: 30000,
    maxRedirects: 2,
  };
  return request(config);
};

const put = async (url, body) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: API_BASE_URL,
    method: "put",
    headers: headers,
    data: body,
    timeout: 30000,
    maxRedirects: 2,
  };
  return request(config);
};

const filePost = async (payload) => {
  // const Token = localStorage.getItem("token");
  const token = Cookies.get("token");
  const config = {
    baseURL: FILE_UPLOAD_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: payload,
    timeout: 600000,
    // withCredentials: false,
    // responseEncoding: "utf8",
    maxRedirects: 2,
  };
  return request(config);
};

const getZoom = async (url, params = {}) => {
  // const token = await localStorage.getItem("token");
  const token = Cookies.get("token");
  const header = {
    "Content-Type": "application/json",
    // data: "sample",
    Authorization: `Bearer ${token}`,
    PLATFORM: "WEB",
  };
  const config = {
    url,
    baseURL: ZOOM_API_URL,
    method: "get", // default
    headers: header,
    params: params,
    timeout: 30000, // default is `0` (no timeout)// 30 sec
    maxRedirects: 2, // default
  };
  return request(config);
};

const NetworkClient = {
  getWithAuth,
  postWithAuth,
  getWithoutAuth,
  postWithoutAuth,
  get,
  post,
  del,
  put,
  filePost,
  getZoom,
};

export default NetworkClient;
